import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Router from 'vue-router'
import {promisShow} from "@/utils/common"
// import {Message} from 'element-ui' 

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    meta: { menu: 'Home',Construction:true,keepAlive:false },
    component: Home
  },
  {
    path: '/test',
    name: 'test',
    meta: { keepAlive:false },
    component: () => import(/* webpackChunkName: "about" */ '../components/test.vue')
  },
  {
    path: '/about',
    name: 'About',
    meta: { keepAlive:false },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/hello',
    meta: { keepAlive:false },
    name: 'HelloWorld',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../components/HelloWorld.vue')
  },
  {
    path: '/leaf',
    name: 'leaf',
    meta: { keepAlive:false },
    component: () => import(/* webpackChunkName: "about" */ '../components/leafletTest.vue')
  },
  {
    path: '/satelliteData',
    name: 'satelliteData',
    meta: { menu: 'Satellite',Construction:true ,keepAlive:true  },
    component: () => import(/* webpackChunkName: "about" */ '../views/satellite-data/satelliteData.vue')
  },
  {
    path: '/map',
    name: 'map',
    meta: { keepAlive:false },
    component: () => import('../components/BaseMap.vue')
  },
  {
    path: '/satellite/satelliteInfo',
    name: 'satelliteInfo',
    meta: { menu: 'Satellite',Construction:true,keepAlive:false  },
    component: () => import(/* webpackChunkName: "about" */ '../views/satellite-data/satellite-info/satellite-info.vue')
  },
  {
    path: '/devcenter',
    name: 'devcenter',
    meta: {
      requireAuth: true, // 判断是否需要登录
      level:2,
      keepAlive:false,
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/devcenter/devcenter.vue')
  },
  {
    path: '/AlgorithmManager',
    name: 'AlgorithmManager',
    meta: {keepAlive:false},
    component: () => import(/* webpackChunkName: "about" */ '@/views/AlgorithmManager/index.vue')
  },
  {
    path: '/AlgorithmScheduling',
    name: 'AlgorithmScheduling',
    meta: {keepAlive:false},
    component: () => import(/* webpackChunkName: "about" */ '@/views/AlgorithmScheduling/index.vue')
  },
  {
    path: '/sgsmanager',
    name: 'sgsmanager',
    meta: {
      requireAuth: true, // 判断是否需要登录
      level:3,
      keepAlive:false
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/sgsmanager/sgsmanager.vue')
  },
  {
    path: '/RpaManager',
    name: 'RpaManager',
    meta: {
      requireAuth: true, // 判断是否需要登录
      level:3,
      keepAlive:false
    },
    component: () => import(/* webpackChunkName: "about" */ '../views/RpaManager/RpaManager.vue')
  },
  {
    path: '/notice',
    name: 'Notice',
    meta: {keepAlive:false},
    component: () => import(/* webpackChunkName: "about" */ '@/views/notice/index.vue')
  },
  {
    path: '/noticemanage',
    name: 'noticeManage',
    meta: { Construction:true,keepAlive:false},
    component: () => import(/* webpackChunkName: "about" */ '@/views/noticeManage/index.vue')
  },
  {
    path: '/systemNotice',
    name: 'systemNotice',
    meta: { Construction:true,keepAlive:false},
    component: () => import(/* webpackChunkName: "about" */ '@/views/noticeManage/systemNotice.vue')
  },
  {
    path: '/mycollect',
    name: 'MyCollect',
    meta: { Construction:true,keepAlive:false  },
    component: () => import(/* webpackChunkName: "about" */ '@/views/myCollect/index.vue')
  },
  {
    path: '/mysubs',
    name: 'MySubs',
    meta: { Construction:true,keepAlive:false  },
    component: () => import(/* webpackChunkName: "about" */ '@/views/mySubs/index.vue')
  },
  {
    path: '/order',
    name: 'Order',
    meta: { Construction:true,keepAlive:false  },
    component: () => import('../views/Order.vue')
  },
  {
    path: '/product',
    meta: { menu: 'Product',keepAlive:true},
    name: 'product',
    component: () => import('../views/product-data/ProductData.vue')
  },
  {
    path: '/product-detail',
    meta: { menu: 'Product',keepAlive:false },
    name: 'product-detail',
    component: () => import('../views/product-data/ProductDetail.vue')
  },
  {
    path: '/productUpload',
    name: 'productUpload',
    meta: {
      requireAuth: true, // 判断是否需要登录
      level:2,
      keepAlive:false
    },
    component: () => import('@/views/product-upload/index.vue')
  },
  {
    path: '/satelliteDataApply',
    meta: {
      requireAuth: true, // 判断是否需要登录
      level:2,
      Construction:true,
      keepAlive:false
    },
    name: 'satelliteDataApply',
    component: () => import('@/views/satelliteDataApply/index.vue')
  },
  {
    path: '/DataDistributionConvergence',
    meta: {
      requireAuth: true, // 判断是否需要登录
      level:2,
      keepAlive:false
    },
    name: 'DataDistributionConvergence',
    component: () => import('@/views/DataDistributionConvergence/index.vue')
  },
  {
    path: '/shopcar',
    name: 'shopcar',
    component: () => import('@/views/shop-car/shopcar.vue'),
    meta: {
      requireAuth: true, // 判断是否需要登录
      level:1,
      Construction:true,
      keepAlive:false
    }
  },
  {
    path: '/cloudComputing',
    name: 'cloudComputing',
    component: () => import('@/views/cloudComputing/index.vue'),
    meta: {
      requireAuth: true, // 判断是否需要登录
      level:2,
      Construction:true,
      keepAlive:false
    }
  },
  {
    path: '/newsmanage',
    name: 'newsManage',
    meta: { 
      Construction:true,
      keepAlive:false },
    component: () => import('@/views/newsManage/index.vue'),
  },
  {
    path: '/newslist',
    name: 'newsList',
    meta: { Construction:true,
      keepAlive:false  },
    component: () => import('@/views/newsManage/newsList.vue'),
  },
  //算法审核
  {
    path: '/algorithmApproval',
    name: 'algorithmApproval',
    meta: { Construction:true,
      keepAlive:false  },
    component: () => import('@/views/algorithmApproval/index.vue'),
  },
  //产品审核
  {
    path: '/productApproval',
    name: 'productApproval',
    meta: { Construction:true,
      keepAlive:false  },
    component: () => import('@/views/productApproval/index.vue'),
  },
  //卫星数据审核审核
  {
    path: '/satelliteDataApproval',
    name: 'satelliteDataApproval',
    meta: { Construction:true,
      keepAlive:false  },
    component: () => import('@/views/satelliteDataApproval/index.vue'),
  },
  {
    path: '/webmain',
    name: 'webmain',
    meta: { 
      Construction:true ,
      requireAuth: true, // 判断是否需要登录
      level:1,
      keepAlive:false
    },
    component: () => import('@/views/webmain/webmain.vue')
  },
  {
    path: '/map-show',
    name: 'map-show',
    meta: { 
      Construction:true ,
      requireAuth: true, // 判断是否需要登录
      level:1,
      keepAlive:false
    },
    component: () => import('@/views/map-show/MapShow')
  },
  {
    path: '/news',
    meta: { menu: 'News',
    keepAlive:false},
    name: 'News',
    component: () => import('../views/news/Home.vue')
  },
  {
    path: '/DataResource',
    name: 'DataResource',
    meta:{keepAlive:false},
    component: () => import('@/views/dataResource/dataResource')
  },
  {
    path: '/OrbitPrediction',
    name: 'OrbitPrediction',
    meta:{keepAlive:false},
    component: () => import('@/views/orbit-prediction/OrbitPrediction')
  },
  {
    path: '/article',
    name: 'article',
    meta:{keepAlive:false},
    component: () => import('@/views/aboutUs/article')
  },
  {
    path: '/organize',
    name: 'organize',
    meta:{keepAlive:false},
    component: () => import('@/views/aboutUs/organize')
  },
  {
    path: '/introduction',
    name: 'introduction',
    meta:{keepAlive:false},
    component: () => import('@/views/aboutUs/introduction')
  },
  {
    path: '/contact',
    name: 'contact',
    meta:{keepAlive:false},
    component: () => import('@/views/aboutUs/contact')
  },
  {
    path: '/course',
    name: 'course',
    meta:{keepAlive:false},
    component: () => import('@/views/aboutUs/course')
  },
  {
    path: '/regist',
    name: 'regist',
    meta: { Construction:true ,keepAlive:false },
    component: () => import('@/views/regist/index')
  },
  {
    path: '/mymessage',
    name: 'myMessage',
    meta: { Construction:true,keepAlive:false  },
    component: () => import('@/views/myMessage/index')
  },
  {
    path: '/seaice',
    name: 'seaIce',
    meta:{keepAlive:false},
    component: () => import('@/views/decision/seaIce')
  },
  {
    path: '/algorithm',
    meta: { menu: 'Algorithm',keepAlive:false },
    name: 'Algorithm',
    component: () => import('../views/Algorithm/AlgorithmList')
  },
  {
    path: '/videoTutorial',
    meta: { 
      menu: 'videoTutorial',
      requireAuth: true, // 判断是否需要登录
      keepAlive:false },
    name: 'VideoTutorial',
    component: () => import('@/views/videoTutorial/index')
  },
  {
    path: '/operat',
    meta: { 
      menu: 'Operat',
      requireAuth: true, // 判断是否需要登录
      keepAlive:false },
    name: 'Operat',
    component: () => import('@/views/Operat/index')
  },
  {
    path: '/downfile',
    meta: { 
      menu: 'downFile',
      requireAuth: true, // 判断是否需要登录
      keepAlive:false },
    name: 'downFile',
    component: () => import('@/views/Operat/scriptDown')
  },
  {
    path: '/algorithmDetail',
    meta: { menu: 'AlgorithmDetail',keepAlive:false },
    name: 'AlgorithmDetail',
    component: () => import('../views/Algorithm/AlgorithmDetail')
  },
]

const router = new VueRouter({
  // mode:'history',
  routes
})
router.beforeEach((to, from, next) => {
  //根据字段判断是否路由过滤
  // if(!to.meta.Construction){
  //   Message.warning('努力建设中');
  //   return
  // }
  sessionStorage.setItem('router-from',from.name)
  if (to.meta.requireAuth) {
    if(to.meta.level===1){
      if(promisShow(1)){
        return
      }
    }else if(to.meta.level===2){
      if(promisShow(2)){
        return
      }
    }else{
      if(promisShow(3)){
        return
      }
    }
  }
  next()
});

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router
